import {ChangeDetectorRef, Component, Input, OnInit, TemplateRef} from '@angular/core';
import {NbDialogRef} from "@nebular/theme";
import {ColDef, ColType} from "../../interfaces/colDef";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BSValidators} from "../../shared/bsvalidators";
import {Globals} from "../../shared/Globals";
import {SubscribedComponent} from "../../subscribed.component";

export enum EditType{
  EDIT,
  ADD
}

@Component({
    selector: 'bst-edit-dialog',
    templateUrl: './edit-dialog.component.html',
    styleUrls: ['../../project/projects.component.scss', './edit-dialog.component.scss'],
    standalone: false
})
export class EditDialogComponent<T> extends SubscribedComponent{

  @Input() public readonly formChanged: (value: any, form:FormGroup, self: EditDialogComponent<T>) => Promise<void> = null;
  @Input() public readonly formCreated: (form: FormGroup, self: EditDialogComponent<T>) => Promise<void> = null;

  public type: EditType = EditType.EDIT;
  public title: string;
  public description: ColDef[]
  public data: T;
  public subtitle: string = null;
  public form: FormGroup;
  public ColType = ColType;
  public Globals = Globals;
  public canEditColumn: (col: ColDef, data: T, value: any) => boolean = null;

  public EditType = EditType;

  constructor(protected ref: NbDialogRef<EditDialogComponent<T>>,
              protected fb: FormBuilder,
              protected cd: ChangeDetectorRef) {
    super();


  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    const format = (stuff: ColDef[], data: any) => {
      const items = {};
      stuff.forEach((col: ColDef) => {
        const validators = [];
        if(col.required){
          validators.push(BSValidators.required);
        }
        if(col.validators?.length){
          col.validators.forEach((v) => {
            validators.push(v);
          });
        }
        if(col.form instanceof FormGroup || col.form instanceof FormControl){
          items[col.name] = col.form;
        }
        else if(col.type === ColType.CUSTOM && col.colDefs){
          items[col.name] = this.fb.group(format(col.colDefs, data ? data[col.name] : null));
        }
        else {
          const val = data ? data[col.name] : (typeof col.default !== 'undefined' ? col.default : null);
          items[col.name] = [{
            value: val,
            disabled: col.disabled || (this.canEditColumn && !this.canEditColumn(col, data, val)) },
            validators];
        }
      });
      return items;
    };

    if(!this.form) {
      this.form = this.fb.group(format(this.description, this.data));
    }

    this.subs.push(this.form.valueChanges.subscribe(async (value) => {
      if(this.formChanged){
        await this.formChanged(value, this.form, this);
      }
    }));

    if(this.formCreated){
      await this.formCreated(this.form, this);
    }
  }

  cancel() {
    this.ref.close(null);
  }

  /** Run a column's inline action (e.g. "+ New client"); append + select the result. */
  async runColAction(col: ColDef): Promise<void> {
    if (!col.action) { return; }
    const entry = await col.action.handler();
    if (entry) {
      col.list = [...(col.list ?? []), entry];
      // Render the new option BEFORE selecting it. nb-select resolves a written
      // value against the options it holds at that moment, and its own retry
      // cannot cover this case: writeValue() only queues a value for retry when
      // the select has no options at all, so a value that misses among options
      // that DO exist is dropped silently and never retried. The result was a
      // blank picker sitting on a correct form value, which reads as the new
      // client not having been created (#1194).
      this.cd.detectChanges();
      this.form.get(col.name)?.setValue(entry.id);
    }
  }

  submit() {
    const something = {...this.data, ...this.form.value};
    this.ref.close(something);
  }
}
